export const MarketAbusePermissions = {
  default: 'User.RiskMonitoring.MarketAbuse',
  consolidatedView: 'User.RiskMonitoring.MarketAbuse.ConsolidatedView',
  tradingVolumeTab: 'User.RiskMonitoring.MarketAbuse.TradingVolumeTab',
  marInstrumentsAndNotificationsTab: 'User.RiskMonitoring.MarketAbuse.MarInstrumentsAndNotificationsTab',
} as const;
